// extracted by mini-css-extract-plugin
module.exports = {"container":"searchResultSummary_container__un8PF","header":"searchResultSummary_header__0ihVI","search":"searchResultSummary_search__p7oF_"};